import { render } from "./GroupFullCard.vue?vue&type=template&id=a04bcf26&scoped=true"
import script from "./GroupFullCard.vue?vue&type=script&lang=js"
export * from "./GroupFullCard.vue?vue&type=script&lang=js"

import "./GroupFullCard.vue?vue&type=style&index=0&id=a04bcf26&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a04bcf26"]])

export default __exports__